import React, { useContext } from 'react';

import OrderStatus from '../../../components/order/Status';
import { UserContext } from '../../../contexts';
import { Visible } from '../../../core/components';

const ProductDetails = ({ order, item, newStatus, summary }) => {
  const { user } = useContext(UserContext);
  let status = order?.status;

  if (newStatus) {
    status = newStatus;
  }

  return (
    <div className="col-product item-col">
      <div className="d-flex flex-row gap-2">
        {!summary && <OrderStatus status={status} />}
        {!!user.is_admin && !!order?.costs_finalised && (
          <img src="/assets/icons/alert-success.svg" />
        )}
      </div>
      <div className="brand">{item?.listing?.product?.brand?.name}</div>
      <div className="model">{item?.listing?.product?.model?.name}</div>
      <div className="reference">{item?.listing?.product?.reference_number}</div>

      <Visible when={order.px_request_id}>
        <div className="seller">
          Part-X
        </div>
      </Visible>

      <div className="seller">
        Qty: {item?.quantity || 1}
      </div>
    </div>
  );
};

export default ProductDetails;
